<div class="dt-edit-page-wrapper">
  <div #dtEditScrollableDiv class="dt-edit-scroll-content">
    <div class="back-to-top" [class.show]="backtoTopVisible" (click)="scrollToTop()">
      <i class="fa-solid fa-chevron-up"></i>
    </div>

    <dx-validation-group #validationGroup>
      <div class="gpd-inner-page dynamic-table-edit" *ngIf="isOwner || hasEditPermission">
        <div class="gpd-container-header">
          <div class="gpd-header-section">
            <app-gpd-button
              type="text"
              *ngIf="previewVisible"
              stylingMode="text"
              icon="cancel"
              [useSubmitBehavior]="false"
              (onClick)="previewVisible = false"
            ></app-gpd-button>
            <app-gpd-button
              *ngIf="!previewVisible"
              i18n-text="@@preview"
              text="Preview"
              stylingMode="contained"
              type="secondary"
              [useSubmitBehavior]="false"
              (onClick)="previewVisible = true"
            ></app-gpd-button>
          </div>
        </div>
        <div *ngIf="previewVisible" class="gpd-container gt-margin-small-bottom">
          <dx-data-grid
            #grid
            class="gpd-datagrid"
            [dataSource]="[]"
            height="100%"
            [allowColumnReordering]="true"
            [rowAlternationEnabled]="true"
            [wordWrapEnabled]="true"
            useNative="false"
            showScrollbar="always"
            [allowColumnResizing]="true"
            columnResizingMode="widget"
            [columnAutoWidth]="false"
            [showBorders]="true"
            [hoverStateEnabled]="true"
          >
            <dxo-selection mode="single"></dxo-selection>
            <dxo-paging [enabled]="false"> </dxo-paging>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-scrolling mode="standard" [useNative]="true"></dxo-scrolling>
            <ng-container *ngFor="let field of editTable?.structure">
              <dxi-column *ngIf="!field.isDeleted" [allowResizing]="true" [caption]="field.name">
                <ng-container *ngFor="let field2 of field?.fields">
                  <dxi-column *ngIf="!field2.isDeleted" [allowResizing]="true" [caption]="field2.name"></dxi-column>
                </ng-container>
              </dxi-column>
            </ng-container>
          </dx-data-grid>
        </div>
        <dx-form *ngIf="editTable" validationGroup="validationGroup" [formData]="editTable" [showColonAfterLabel]="false">
          <dxi-item itemType="group" cssClass="gpd-container">
            <dxi-item dataField="tableName" [maxSize]="100">
              <dxo-label i18n-text="@@tableName" text="Table Name" />
              <div *dxTemplate="let data of 'item'">
                <dx-text-box class="gpd-input" [maxLength]="250" [(value)]="editTable.title">
                  <dx-validator validationGroup="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      i18n-message="@@titleRequired"
                      message="Title is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </dxi-item>
            <dxi-item dataField="structure" [label]="{ visible: false }">
              <div *dxTemplate="let data of 'item'">
                <div class="section-container-columns">
                  <span class="field-title" i18n="@@columns">Columns</span>
                  <dx-sortable
                    class="sortable-cards-groups"
                    group="groupsGroup"
                    [allowReordering]="true"
                    [allowDropInsideItem]="true"
                    [moveItemOnDrop]="true"
                    [dropFeedbackMode]="'indicate'"
                    (onReorder)="onGroupReorder($event)"
                    (onAdd)="onFieldAdd($event)"
                    handle=".block-icon"
                    [data]="$safeNavigationMigration(editTable?.structure)"
                    (onDragChange)="onDragChange($event)"
                    style="padding-bottom: 0px !important"
                  >
                    <ng-container
                      *ngFor="let field of editTable?.structure; index as i"
                      [ngTemplateOutlet]="fieldTemplate"
                      [ngTemplateOutletContext]="{
                        field: field,
                        index: i,
                        level: 1,
                      }"
                    />

                    <ng-template #fieldTemplate let-field="field" let-index="index" let-level="level">
                      <div
                        *ngIf="field && field.isDeleted == false"
                        class="field-container"
                        style="margin-bottom: 0px !important"
                      >
                        <i class="dx-icon dx-icon-dragvertical block-icon"></i>
                        <div class="field-form">
                          <div class="field-inputs">
                            <dx-form [formData]="field" width="100%" [showColonAfterLabel]="false">
                              <dxi-item itemType="group" [colCount]="2">
                                <dxi-item dataField="name">
                                  <div *dxTemplate="let data of 'item'">
                                    <dx-text-box class="gpd-input" [maxLength]="100" [(value)]="field.name">
                                      <dx-validator validationGroup="validationGroup">
                                        <dxi-validation-rule
                                          type="required"
                                          i18n-message="@@nameRequired"
                                          message="Name is required"
                                        ></dxi-validation-rule>
                                      </dx-validator>
                                    </dx-text-box>
                                  </div>
                                </dxi-item>
                                <dxi-item itemType="group">
                                  <dxi-item dataField="fieldId" *ngIf="field.group == false">
                                    <dxo-label i18n-text="@@field" text="Field"></dxo-label>
                                    <div *dxTemplate="let data of 'item'">
                                      <dx-select-box
                                        class="gpd-input"
                                        [(value)]="field.fieldId"
                                        [dataSource]="fieldLookup"
                                        displayExpr="displayName"
                                        valueExpr="fieldId"
                                        (onValueChanged)="onFieldChanged($event, field)"
                                      >
                                        <dx-validator validationGroup="validationGroup">
                                          <dxi-validation-rule
                                            type="required"
                                            i18n-message="@@fieldRequired"
                                            message="Field is required"
                                          ></dxi-validation-rule>
                                        </dx-validator>
                                      </dx-select-box>
                                    </div>
                                  </dxi-item>
                                  <dxi-item dataField="value1" *ngIf="field.fieldConfig?.contextConfig.value1 != null">
                                    <dxo-label [text]="field.fieldConfig?.contextConfig.value1.label"></dxo-label>
                                    <div *dxTemplate="let data of 'item'">
                                      <ng-container [ngSwitch]="field.fieldConfig.contextConfig.value1.type">
                                        <ng-container *ngSwitchCase="'text'">
                                          <dx-text-box
                                            class="gpd-input"
                                            style="background-color: white"
                                            [maxLength]="250"
                                            [(value)]="field.value1"
                                          >
                                            <dx-validator validationGroup="validationGroup">
                                              <dxi-validation-rule
                                                *ngIf="field.fieldConfig.contextConfig.value1.required"
                                                type="required"
                                                i18n-message="@@fieldRequired"
                                                message="Field is required"
                                              ></dxi-validation-rule>
                                            </dx-validator>
                                          </dx-text-box>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'select'">
                                          <dx-select-box
                                            class="gpd-input"
                                            style="background-color: white"
                                            i18n-placeholder="@@enterGroupName"
                                            [(value)]="field.value1"
                                            [dataSource]="lookUps[field.fieldConfig.contextConfig.value1.lookup]"
                                            displayExpr="title"
                                            valueExpr="id"
                                          >
                                            <dx-validator validationGroup="validationGroup">
                                              <dxi-validation-rule
                                                type="required"
                                                i18n-message="@@fieldRequired"
                                                message="Field is required"
                                              ></dxi-validation-rule>
                                            </dx-validator>
                                          </dx-select-box>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'tasks'">
                                          <dx-drop-down-box
                                            class="gpd-input"
                                            [(value)]="field.value1"
                                            [dataSource]="lookUps.tasks"
                                            displayExpr="title"
                                            valueExpr="id"
                                          >
                                            <div *dxTemplate="let data of 'content'">
                                              <dx-tree-view
                                                [items]="lookUps.tasks"
                                                dataStructure="plain"
                                                keyExpr="nodeId"
                                                displayExpr="title"
                                                searchExpr="title"
                                                searchMode="contains"
                                                [searchEnabled]="true"
                                                selectionMode="single"
                                                [selectByClick]="true"
                                                parentIdExpr="parentNodeId"
                                                (onItemClick)="
                                                  $event.itemData.type != 'group'
                                                    ? (field.value1 = $event.itemData.id)
                                                    : ($event.cancel = true)
                                                "
                                              >
                                              </dx-tree-view>
                                            </div>
                                            <dx-validator validationGroup="validationGroup">
                                              <dxi-validation-rule
                                                type="required"
                                                i18n-message="@@taskRequired"
                                                message="Task is required"
                                              >
                                              </dxi-validation-rule>
                                            </dx-validator>
                                          </dx-drop-down-box>
                                        </ng-container>
                                      </ng-container>
                                    </div>
                                  </dxi-item>
                                </dxi-item>
                              </dxi-item>
                            </dx-form>
                          </div>
                          <div *ngIf="field.group" style="display: flex; gap: 16px; flex-direction: column">
                            <dx-sortable
                              class="sortable-cards-groups"
                              [allowReordering]="true"
                              group="groupsGroup"
                              [allowDropInsideItem]="false"
                              [moveItemOnDrop]="true"
                              (onReorder)="onGroupReorder($event)"
                              handle=".block-icon"
                              (onAdd)="onFieldAdd($event)"
                              [dropFeedbackMode]="'indicate'"
                              [data]="field.fields"
                            >
                              <ng-container
                                *ngFor="let field of field.fields; index as i"
                                [ngTemplateOutlet]="fieldTemplate"
                                [ngTemplateOutletContext]="{
                                  field: field,
                                  index: i,
                                  level: 2,
                                }"
                              />
                            </dx-sortable>
                            <div class="add-field-container">
                              <app-gpd-button
                                type="text"
                                i18n-text="@@addField"
                                text="Add Field"
                                [useSubmitBehavior]="false"
                                icon="add"
                                (onClick)="addField(field.fields)"
                                style.float="right"
                              ></app-gpd-button>
                            </div>
                          </div>
                        </div>
                        <div class="trash-container" [style.align-items]="field.group ? 'start' : 'center'">
                          <div style="display: flex; align-items: center; gap: 8px">
                            <div *ngIf="level < 2" class="field-row" style.float="right">
                              <div class="field-column">
                                <dx-check-box
                                  [(value)]="field.group"
                                  (onValueChanged)="onGroupCheckboxChanged($event, field)"
                                />
                                <div class="field-label" i18n="@@group">Group</div>
                              </div>
                            </div>

                            <app-svg-icon
                              style="cursor: pointer;"
                              color="#C20909"
                              icon="delete"
                              [size]="20"
                              [strokeWidth]="1.5"
                              (click)="deleteField(field); validationGroup.instance._refresh()"
                            />
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </dx-sortable>
                  <div class="add-section-container">
                    <app-gpd-button
                      i18n-text="@@addSection"
                      text="Add Section"
                      stylingMode="contained"
                      [useSubmitBehavior]="false"
                      icon="add"
                      (onClick)="addField($safeNavigationMigration(editTable?.structure))"
                    ></app-gpd-button>
                  </div>
                </div>
              </div>
            </dxi-item>
          </dxi-item>
          <dxi-item itemType="group" [colCount]="2">
            <dxi-item itemType="group" cssClass="gpd-container">
              <dxi-item dataField="filters" caption="" [label]="{ visible: false }">
                <div *dxTemplate="let data of 'item'">
                  <div class="section-container">
                    <span class="field-title" i18n="@@filters">Filters</span>
                    <div class="filters-list">
                      <ng-container *ngFor="let filter of editTable?.filters">
                        <div class="filter-item" *ngIf="filter.isDeleted != true">
                          <dx-form [formData]="filter" class="filter-form" [showColonAfterLabel]="false">
                            <dxi-item dataField="type">
                              <dxo-label i18n-text="@@filter" text="Filter" />
                              <div *dxTemplate="let data of 'item'">
                                <dx-select-box
                                  [(items)]="filters"
                                  displayExpr="display"
                                  valueExpr="value"
                                  [(value)]="filter.type"
                                  i18n-placeholder="@@filterPlaceholder"
                                  placeholder="Select a Filter..."
                                  (onValueChanged)="filterValueChanged($event)"
                                  [readOnly]="filter.type"
                                >
                                  <dx-validator validationGroup="validationGroup">
                                    <dxi-validation-rule
                                      type="required"
                                      i18n-message="@@filterRequired"
                                      message="Filter is required"
                                    ></dxi-validation-rule>
                                  </dx-validator>
                                </dx-select-box>
                              </div>
                            </dxi-item>
                            <dxi-item dataField="value" caption="Value">
                              <dxo-label i18n-text="@@option" text="Option" />
                              <div *dxTemplate="let data of 'item'">
                                <dx-tag-box
                                  *ngIf="filter.type != 'partner' && filter.type != 'epc'"
                                  [items]="lookUps[filter.type]"
                                  [(value)]="filter.value"
                                  displayExpr="title"
                                  [showSelectionControls]="true"
                                  valueExpr="id"
                                  applyValueMode="useButtons"
                                  [searchEnabled]="true"
                                  [acceptCustomValue]="false"
                                  [disabled]="!filter.type"
                                >
                                  <dx-validator validationGroup="validationGroup">
                                    <dxi-validation-rule
                                      type="required"
                                      i18n-message="@@filterValueRequired"
                                      message="Filter Value is required"
                                    ></dxi-validation-rule>
                                  </dx-validator>
                                </dx-tag-box>
                                <app-contacts-dropdown-box
                                  *ngIf="filter.type == 'partner' || filter.type == 'epc'"
                                  [companies]="lookUps.company"
                                  [persons]="lookUps.person"
                                  [contactId]="$safeNavigationMigration(filter.value?.id)"
                                  [contactType]="$safeNavigationMigration(filter.value?.type)"
                                  (onContactSelected)="
                                    filter.value = {
                                      id: $event.data.id,
                                      type: $event.type,
                                    }
                                  "
                                >
                                </app-contacts-dropdown-box>
                              </div>
                            </dxi-item>
                          </dx-form>
                          <div class="trash-container" [style.align-items]="'start'">
                            <app-svg-icon
                              style="cursor: pointer;"
                              color="#C20909"
                              icon="delete"
                              [size]="20"
                              [strokeWidth]="1.5"
                              class="board-answer-icon"
                              (click)="deleteFilter(filter); validationGroup.instance._refresh()"
                            ></app-svg-icon>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="filter-actions">
                      <app-gpd-button
                        type="secondary"
                        icon="add"
                        i18n-text="@@addFilter"
                        text="Add Filter"
                        (onClick)="addFilter()"
                      ></app-gpd-button>
                    </div>
                  </div>
                </div>
              </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" cssClass="gpd-container gt-margin-small-left">
              <dxi-item dataField="users" caption="" [label]="{ visible: false }">
                <div *dxTemplate="let data of 'item'">
                  <div class="section-container">
                    <span class="field-title" i18n="@@users">Users</span>
                    <div class="filters-list">
                      <ng-container *ngFor="let user of editTable?.users">
                        <div class="filter-item" *ngIf="user.isDeleted != true && user.email != table.owner">
                          <dx-form [formData]="user" class="filter-form" [showColonAfterLabel]="false">
                            <dxi-item dataField="email">
                              <dxo-label [visible]="false" />
                              <div *dxTemplate="let data of 'item'">
                                <dx-select-box
                                  [dataSource]="lookUps.users"
                                  [(value)]="user.email"
                                  displayExpr="displayName"
                                  valueExpr="email"
                                  i18n-placeholder="@@selectUserPlaceholder"
                                  placeholder="Select a User..."
                                  searchMode="contains"
                                  [minSearchLength]="2"
                                  [showDataBeforeSearch]="true"
                                  [acceptCustomValue]="false"
                                  [searchEnabled]="true"
                                  [showClearButton]="true"
                                  [readOnly]="!isOwner || user.email"
                                  (onValueChanged)="userValueChanged($event)"
                                >
                                </dx-select-box>
                              </div>
                            </dxi-item>
                            <dxi-item dataField="canEdit">
                              <dxo-label i18n-text [visible]="false" />
                              <div *dxTemplate="let data of 'item'">
                                <dx-check-box
                                  [readOnly]="!isOwner || user.email == table.owner"
                                  [(value)]="user.canEdit"
                                  i18n-text="@@canEditUserPermission"
                                  text="Can Edit"
                                >
                                </dx-check-box>
                              </div>
                            </dxi-item>
                          </dx-form>
                          <div class="trash-container" [style.align-items]="'start'">
                            <app-svg-icon
                              style="cursor: pointer;"
                              color="#C20909"
                              icon="delete"
                              [size]="20"
                              [strokeWidth]="1.5"
                              class="board-answer-icon"
                              (click)="deleteUser(user); validationGroup.instance._refresh()"
                            ></app-svg-icon>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="filter-actions">
                      <app-gpd-button
                        #addUserButton
                        type="secondary"
                        icon="add"
                        i18n-text="@@addUser"
                        text="Add User"
                        [disabled]="!isOwner"
                        (onClick)="addUser()"
                        class="user-btn"
                      ></app-gpd-button>
                      <dx-popover
                        *ngIf="!isOwner"
                        target=".user-btn"
                        showEvent="mouseenter"
                        hideEvent="mouseleave"
                        [wrapperAttr]="{ class: 'gpd-popover' }"
                        position="bottom"
                        style="display: none"
                      >
                        <div class="help-context" i18n="@@addUserHelp">
                          You cannot add users to the table as you are not the author.
                        </div>
                      </dx-popover>
                    </div>
                  </div>
                </div>
              </dxi-item>
            </dxi-item>
          </dxi-item>
        </dx-form>
      </div>
    </dx-validation-group>
  </div>

  <app-form-footer>
    <app-gpd-button
      footerLeft
      *ngIf="isOwner && table.id != 0"
      i18n-text="@@delete"
      text="Delete"
      type="danger"
      [useSubmitBehavior]="false"
      icon="delete"
      (onClick)="deleteTable($event)"
    ></app-gpd-button>
    <app-gpd-button
      footerRight
      i18n-text="@@cancel"
      text="Cancel"
      type="secondary"
      icon="cancel"
      [useSubmitBehavior]="false"
      (onClick)="back()"
    ></app-gpd-button>
    <app-gpd-button
      footerRight
      *ngIf="isOwner || hasEditPermission"
      i18n-text="@@save"
      text="Save"
      type="primary"
      [useSubmitBehavior]="false"
      icon="check"
      (onClick)="validationGroup.instance._refresh(); saveTable($event)"
      validationGroup="validationGroup"
    ></app-gpd-button>
  </app-form-footer>
</div>

<app-delete-popup
  [visible]="popupContent"
  (onAbort)="popupContent?.cancelFunction()"
  (onConfirm)="popupContent?.confirmFunction()"
  [message]="$safeNavigationMigration(popupContent?.text)"
>
</app-delete-popup>
